<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div>
                <h3>{{ employeeName }} Review</h3>
                <div v-for="(f, i) in formData.reviewFields" :key="i">
                    <h3>{{ f.name }}</h3>
                    <div v-if="f.type == 'text'"><input type="text" v-model="f.value" /></div>
                    <div v-else-if="f.type == 'multitext'"><textarea v-model="f.value"></textarea></div>
                    <div v-else-if="f.type == 'date'"><input type="date" v-model="f.value" /></div>
                    <div v-else-if="f.type == 'select'">
                        <select v-model="f.value">
                            <option v-for="(op, j) in f.options" :key="'o'+j" :value="op">{{ op }}</option>
                        </select>
                    </div>
                </div>
                <div class="checkbox-input" style="margin-top:10px">
                    <input type="checkbox" v-model="formData.sendEmail" />
                    <h3 style="margin-bottom:5px">Send Email?</h3>
                </div>
                <div class="checkbox-input">
                    <input type="checkbox" v-model="formData.sendText" />
                    <h3>Send Text?</h3>
                </div>
                <input style="margin-top:5px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'AddEmployeeReview',
    props: [ 'employeeReviewFields', 'employee' ],
    components: {
        
    },
    data() {
        return {
            disableButton: false,
            formData: {
                employeeID: null as any,
                reviewFields: [] as any,
                sendEmail: false,
                sendText: false
            },
            loaded: false,
            employeeName: ''
        }
    },
    async created() {
        this.formData.employeeID = this.employee.ID;
        this.employeeName = this.employee.Name;
        this.formData.reviewFields = JSON.parse(JSON.stringify(this.employeeReviewFields));

        this.loaded = true;
    },
    methods: {
        async submit() {
            console.log(this.formData);

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/employees/review`, this.formData)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        }
    }
});
</script>
